import Content from "../components/Content";
import PageTemplate from "../components/PageTemplate";
import Divider from "../components/Divider";
import { useEffect } from "react";
import PageFade from "../motions/PageFade";

function Events() {
  console.log("Events rendered");

  useEffect(() => {
    console.log("Events mounted");

    return () => {
      console.log("Events unmounted");
    };
  }, []);

  return (
    <PageFade>
      <PageTemplate title="Events" textColor="text-gold">
        <Content>
          <div className="mb-10"> {/**Added margin so there is some gap at the bottom of the page */}
            <div>
              <div className="space-y-6">
                <div className="text-gold subheading text-xl lg:text-2xl xl:text-3xl">
                  WELCOME PARTY
                </div>
                <div>
                  <p>Friday, April 24, 2026</p>
                  <p>6:30 PM – 9:30 PM</p>
                </div>
                <div className="venue-address">
                  <div>
                    <a
                      href="https://www.google.com/maps/place/Bonne+Vie+Cafe+and+Bistro/@38.9168466,-77.0396938,688m/data=!3m2!1e3!4b1!4m6!3m5!1s0x89b7b7d18d9bb93d:0x862a2db661eec253!8m2!3d38.9168425!4d-77.0371189!16s%2Fg%2F11xkz4j2c3?entry=ttu&g_ep=EgoyMDI2MDQwNy4wIKXMDSoASAFQAw%3D%3D"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline inline-block"
                    >
                      <p>Bonne Vie Cafe & Bistro</p>
                      <p className="text-base">(formerly known as Baby Shank)</p>
                      <p>1604 U Street </p>
                      <p>NW, Washington, DC 20009</p>
                    </a>
                  </div>
                </div>
                <p>Join us the night before the wedding for an evening of celebration. We'll be treating you to a buffet dinner and drinks, so please come hungry! This is a great chance to mingle and spend time together before the big day.</p>
                <p className="text-gold"><b>Dress Code:</b> Dressy Casual</p>
              </div>
              <Divider className={`border-gold border-t w-1/2 mx-auto my-16`} />
              <div className="space-y-6">
                <div className="text-gold subheading text-2xl lg:text-3xl xl:text-4xl">
                  WEDDING
                </div>
                <div>
                  <p>Saturday, April 25, 2026</p>
                  <p>4:00 PM – 11:00 PM</p>
                </div>
                <div className="venue-address">
                  <div>
                    <a
                      href="https://www.google.com/maps/place/Meridian+International+Center/@38.920454,-77.0404909,1474m/data=!3m2!1e3!4b1!4m6!3m5!1s0x89b7b7dc6eb48173:0xc1a9105beb482cb3!8m2!3d38.920454!4d-77.037916!16zL20vMDRqdjRw?entry=ttu&g_ep=EgoyMDI1MDcwOC4wIKXMDSoASAFQAw%3D%3D"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:underline inline-block"
                    >
                      <p>Meridian House</p>
                      <p>1630 Crescent Place</p>
                      <p>NW, Washington, DC 20009</p>
                    </a>
                  </div>
                </div>
                <p>Doors to the venue will open to guests at 3:30 PM.</p>

                <div className="mt-8 flex justify-center">
                  <div className="w-full max-w-lg">
                    <div className="text-gold font-semibold mb-4 text-center">
                      Schedule
                    </div>

                    <ul className="space-y-2">
                      <li className="flex justify-between border-b border-gray-200 pb-1">
                        <span>4:00 PM</span>
                        <span>Ceremony</span>
                      </li>
                      <li className="flex justify-between border-b border-gray-200 pb-1">
                        <span>4:30 PM</span>
                        <span>Cocktail Hour</span>
                      </li>
                      <li className="flex justify-between border-b border-gray-200 pb-1">
                        <span>5:30 PM</span>
                        <span>Tea Ceremony</span>
                      </li>
                      <li className="flex justify-between">
                        <span>6:30 PM</span>
                        <span>Dinner</span>
                      </li>
                    </ul>
                  </div>
                </div>                <p className="text-gold"><b>Dress Code:</b> Black Tie or Formal Attire</p>
                <div className="flex justify-center">
                  <img
                    alt="Meridian house"
                    src="/assets/images/events/meridian-house-painting.jpg"
                    className="border border-customGray mx-auto max-w-full w-[500px]"
                  />
                </div>
              </div>
              <div className="mt-16 space-y-6">
                <div className="text-gold subheading text-xl lg:text-2xl xl:text-3xl">
                  PARKING INFORMATION
                </div>
                <p>There is a small private parking lot available on the other side of the neighboring White-Meyer House. It can accommodate approximately 30 cars. Since we're expecting around 100 guests, we kindly ask that those who are able to carpool or use rideshare services do so.</p>
                <p>Crescent Place is a one-way street. As you drive down, you'll see Meridian House on your right-hand side. Just past it is the White-Meyer House, followed by the parking lot designated for guests.</p>
                <p>If you plan to drive, please allow a few extra minutes to walk from the lot to the venue entrance.</p>
                <div className="flex justify-center">
                  <img
                    alt="Parking Directions"
                    src="/assets/images/events/meridian-house-parking-map.png"
                    className="mx-auto max-w-full w-[550px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </Content>
      </PageTemplate>
    </PageFade>
  );
}

export default Events;
